/** 用户协议 */
<template>
  <div class="home protocol-home">
    <Layout
      type="HOME"
      pageTitle="需求方管理"
      titleSrc="/menu/homeIcon_black.png"
    >
      <BasiceLayout
        :title="pageTitle"
        class="bonus-code-layout"
      >
      <main class="download-wrap">
        <div class="crm-node-content">
          <el-alert
            title="Tips： 待认证、待确认状态时，用户状态均属于部署中"
            type="success">
          </el-alert>

          <el-select v-model="type" placeholder="请选择" @change="selectType" class="margin-20">
            <el-option
              v-for="item, index in STATUS"
              :key="index"
              :label="item"
              :value="index">
            </el-option>
          </el-select>
          <div v-if="tableData.length">
              <el-table
              :data="tableData"
              align='center'
            >
              <el-table-column
                prop="serverID"
                align='center'
                label="serverID"
              >
              </el-table-column>
              <el-table-column
                label="节点资源类型"
                align='center'
              >
                <template slot-scope="scope">
                  <div v-if="scope.row.serverNetType == 1">动态IP汇聚</div>
                  <div v-else>静态IP专线</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="serverNote"
                label="设备备注"
                align='center'
              >
              </el-table-column>
              <el-table-column
                label="ip"
                align='center'
              >
                <template slot-scope="scope">
                  <div>{{scope.row.serverJumperIP || scope.row.serverExtIP}}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="bandwidthMb"
                align='center'
                label="网络带宽Mbps"
              >
              </el-table-column>
              <el-table-column
                prop="serverLoginAccount"
                align='center'
                label="账号"
              >
              </el-table-column>
              <el-table-column
                prop="serverPasswd"
                align='center'
                label="密码"
              >
              </el-table-column>
              <el-table-column
                prop="serverJumperPort"
                align='center'
                label="端口"
              >
              </el-table-column>
              <!-- 跳转端口 -->
              <el-table-column
                prop="serverIntIP"
                align='center'
                label="服务器管理IP"
              >
              </el-table-column>
              <!-- 网关地址 -->
              <el-table-column
                prop="serverGateway"
                align='center'
                label="网关地址"
              >
              </el-table-column>
              <el-table-column
                prop="serverRecords"
                align='center'
                label="备注"
              >
              </el-table-column>
              <el-table-column
                prop="serverConfigID"
                align='center'
                label="服务关联配置ID"
              >
              </el-table-column>
              <el-table-column
                prop="email"
                align='center'
                label="邮箱"
              >
                <template slot-scope="scope">
                  <div
                    class="bonus-tips"
                    @click="getEmail(scope.row.serverOwnerID)"
                  >{{scope.row.serverAccount}}</div>
                </template>
              </el-table-column>
              <el-table-column
                label="状态"
                align='center'
              >
                <template slot-scope="scope">
                  <div>{{STATUS[scope.row.serverDeployStatus]}}</div>
                </template>
              </el-table-column>
              <!-- 自动部署状态 -->
              <el-table-column
                label="自动部署状态"
                align='center'
              >
                <template slot-scope="scope">
                  <div class="bonus-cursor" @click="clickDeployStatus(scope.row)">查询部署状态</div>
                </template>
              </el-table-column>
              <!-- 打标 -->
              <el-table-column
                label="打标"
                align='center'
              >
                <template slot-scope="scope">
                  <div class="label-button button display-flex-center" v-if="scope.row.serverDeployStatus == 10" @click="changeLabel(scope.row)">打标</div>
                </template>
              </el-table-column>
              <!-- 操作 -->
              <el-table-column
                label="操作"
                align='center'
              >
                <template slot-scope="scope">
                  <div class="label-button button display-flex-center" v-if="scope.row.serverDeployStatus == 2" @click="startDeploy(scope.row)">部署</div>
                </template>
              </el-table-column>
              <!-- 状态修改 -->
              <el-table-column
                label="状态修改"
                align='center'
              >
                <template slot-scope="scope">
                  <el-select
                    v-model="changStatus[scope.$index]"
                    @change="changeStatus(scope.row, scope.$index)"
                  >
                    <el-option
                      v-for="(item, index) in selectStatus"
                      :key="item.value"
                      :label="item.key"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="block display-flex-center">
              <el-pagination
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-size="deviceSize"
                layout="total, prev, pager, next"
                :total="total">
                </el-pagination>
            </div>
          </div>
          <div
            class="text-align-center"
            v-else
          >
            无权限
          </div>
        </div>
      </main>

      <el-dialog
        title="联系方式"
        :visible.sync="dialogVisible"
        width="30%"
      >
        <div>姓名： {{user_name}}</div>
        <div>电话： {{tel}}</div>
        <div>微信/QQ: {{contact}}</div>
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            type="primary"
            @click="dialogVisible = false"
          >确 定</el-button>
        </span>
      </el-dialog>
      <!-- 打标 -->
      <el-dialog
        title="打标"
        :visible.sync="labelStatus"
        width="70%"
      >
        <div class="margin-20">打标机器:  {{labelItem.serverID}}</div>
        <div class="margin-20">选择服务类型： 
          <el-radio-group v-model="labelType">
            <el-radio :label="1">dcache</el-radio>
            <el-radio :label="2">lego</el-radio>
            <el-radio :label="3">lego_p2p</el-radio>
            <el-radio :label="4">mgtv</el-radio>
            <el-radio :label="5">qiniu_cdn</el-radio>
            <el-radio :label="6">ksyun2</el-radio>
            <el-radio :label="7">toutiao</el-radio>
          </el-radio-group>
        </div>
        <div class="margin-20">输入打标Bcode:
          <input type="text" class="input " v-model="labelBcode">
        </div>
        <div class="margin-20">输入机器负责人姓名:
          <input type="text" class="input " v-model="labelOwner">
        </div>
        <div class="margin-20">输入打标主机名:
          <input type="text" class="input " v-model="labelHost">
        </div>
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            type="primary"
            @click="startLabel(1)"
          >写入CMBD</el-button>
          <el-button
            type="primary"
            @click="startLabel(2)"
          >打标</el-button>
        </span>
      </el-dialog>
      <!-- 部署 -->
      <el-dialog
        title="部署"
        :visible.sync="deployStatus"
        width="70%"
      >
        <div class="margin-20">部署机器:  {{deployItem.serverID}}</div>
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            type="primary"
            @click="deploy()"
          >部署机器</el-button>
        </span>
      </el-dialog>
      </BasiceLayout>
    </Layout>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { log } from "util";
import { Message } from "element-ui";
import Header from '@/components/Header.vue';
import Layout from "@/components/CRM/Layout.vue";
import BasiceLayout from "@/components/Common/BasicLayout.vue";

const STATUS = {
  // 0: "待提交",
  // 1: "已提交",
  2: "部署中",
  3: "部署完成",
  4: "无法登陆",
  5: "端口不通",
  6: "拨号错误",
  7: "硬件问题",
  8: "等待官方联系",
  9: "IP冲突" ,
  10: "待认证", //待认证
  11: "待确认", //待确认
  12: "部署错误", //待确认
  13: "拨号修改",
  14: "带宽修改"
};

export default {
  name: "home",
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      tel: "",
      user_name: "",
      contact: "",
      STATUS,
      changStatus: [],
      type: '',
      labelStatus: false,
      labelItem: '',
      labelType: 1,
      labelBcode: '',
      labelHost: '',
      labelOwner: '',
      pageTitle: '',
      deployStatus: false,
      deployItem: '',
      deviceSize: 20,
      currentPage: 1,
    };
  },
  computed: mapState({
    selectStatus: () => {
      let select = [];
      for (var item in STATUS) {
        select.push({
          key: STATUS[item],
          value: item
        });
      }

      return select;
    }
  }),
  components: {
    Header,
    Layout,
    BasiceLayout
  },
  methods: {
    ...mapActions(["getAdminStandardNode", "getAdminContact", "setAdminNodesDialConfig", "getDeployStatus", "setServerLabel"]),
    getEmail(userid) {
      this.getAdminContact({userid}).then(res => {
        this.dialogVisible = true;
        let data = res.data;
        this.tel = data.tel;
        this.user_name = data.user_name;
        this.contact = data.contact;
      });
    },
    changeStatus(item, index) {
      let { serverID, serverConfigID, serverNetType } = item;
      let status = this.changStatus[index];
      console.log(serverConfigID, serverID)

      this.setAdminNodesDialConfig({
        serverID,
        status,
        serverConfigID,
        serverNetType
      }).then(res => {
        if (res.status === 200) {
          Message({
            message: "设置成功",
            type: "success"
          });
          this.updateStandard();
        } else {
          Message({
            message: res.message,
            type: "error"
          });
        }
      });
    },
    updateStandard(data) {
      this.getAdminStandardNode(data).then(res => {
        this.tableData = res.data;
        this.total = res.total
      });
    },
    selectType(item) {
      this.updateStandard({type: this.type});
    },
    clickDeployStatus(item) {
      this.getDeployStatus({ type: `deploy_${item._id}`, redisBD: 'session' }).then(res => {
        let {message} = res;
        if (!message) {
          Message({
            message: '未进行自动部署',
            type: "error"
          });
        } else {
          Message({
            message: res.message,
            type: "success"
          });
        }
      })
    },
    // 打标
    changeLabel(item) {
      this.labelStatus = true;
      this.labelItem = item
    },
    // 部署中部署
    startLabel(type) {
      let {labelType, labelBcode, labelHost, labelItem, labelOwner} = this;

      this.setServerLabel({serverID: labelItem.serverID, labelType, labelBcode, labelHost, labelOwner, type}).then(res => {
        if (res.code === 200) {
          Message({
            message: '执行成功',
            type: 'success'
          });
        } else {
          Message({
            message: res.message,
            type: "error"
          });
        }
      })
    },
    startDeploy(item) {
      this.deployStatus = true;
      this.deployItem = item
    },
    deploy() {
      // 执行部署，type: 3
      let { deployItem } = this;
      let { serverNetType, serverJumperIP, serverID } = deployItem;
      let category;
      if (serverNetType == 0) {
        category = 0;
      } else if (serverNetType == 1) {
        category = serverJumperIP ? 2 : 1;
      }

      this.setServerLabel({serverID: serverID, type: 3, category }).then(res => {
          Message({
            message: JSON.stringify(res),
          });
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      let type = this.type;

      this.updateStandard({ page: val, type });
    },
  },
  created() {
    console.log(this.$route.query.type)
    let type = this.$route.query.type;
    this.type = type;
    if (type == 3) {
      this.updateStandard({ type: Number(type) });
      this.pageTitle = '标准节点部署完成列表';
    } else {
      this.updateStandard();
      this.pageTitle = '标准节点待部署列表';
    }
  }
};
</script>

<style  lang="stylus">
.node-dial-content {
  width: 80%;
}

.crm-node-content{
  padding-top: 80px;
  height: auto;
  margin: 0 auto;
  background: #fff;
  padding: 20px;
  text-align: left;
}
.label-button{
  max-width: 100%;
}
</style>
